import { render, staticRenderFns } from "./ModalCustom.vue?vue&type=template&id=d0d75ac0"
import script from "./ModalCustom.vue?vue&type=script&lang=js"
export * from "./ModalCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports